import { createStore } from '@zen/common-app-parts';
import useIssueStore from './useIssueCancelStore';
import useRedeemStore from './useRedeemStore';
import useVerifyAssetStore from './useVerifyAssetStore';

const _IssueStore = createStore({
  useStoreHook: () => useIssueStore({ defaultValues: { collateralAsset: 'ZP' } }),
  contextDisplayName: 'IssueStoreContext',
});
// cancel is the same as issue, but we want to keep the data separately
const _CancelStore = createStore({
  useStoreHook: () => useIssueStore({ defaultValues: { collateralAsset: 'ZP' } }),
  contextDisplayName: 'CancelStoreContext',
});
// verify event is the same as issue, but we want to keep the data separately
const _VerifyEventStore = createStore({
  useStoreHook: () => useIssueStore({ defaultValues: { collateralAsset: 'ZP' } }),
  contextDisplayName: 'VerifyEventStoreContext',
});
const _VerifyAssetStore = createStore({
  useStoreHook: useVerifyAssetStore,
  contextDisplayName: 'VerifyAssetStoreContext',
});
const _RedeemStore = createStore({
  useStoreHook: useRedeemStore,
  contextDisplayName: 'RedeemStoreContext',
});

export const IssueStore = {
  Provider: _IssueStore.Provider,
  /** @type {() => IssueCancelStore} */
  useStore: _IssueStore.useStore,
};
export const CancelStore = {
  Provider: _CancelStore.Provider,
  /** @type {() => IssueCancelStore} */
  useStore: _CancelStore.useStore,
};
export const VerifyEventStore = {
  Provider: _VerifyEventStore.Provider,
  /** @type {() => IssueCancelStore} */
  useStore: _VerifyEventStore.useStore,
};
export const VerifyAssetStore = {
  Provider: _VerifyAssetStore.Provider,
  /** @type {() => IssueCancelStore} */
  useStore: _VerifyAssetStore.useStore,
};
export const RedeemStore = {
  Provider: _RedeemStore.Provider,
  /** @type {() => RedeemStore} */
  useStore: _RedeemStore.useStore,
};

/**
 * @typedef {{
 *  state: import('./types').IssueCancelState,
 *  actions: import('./types').IssueCancelActions,
 * }} IssueCancelStore
 */

/**
 * @typedef {{
 *  state: import('./types').RedeemState,
 *  actions: import('./types').RedeemActions,
 * }} RedeemStore
 */
